import { PricingEditorModule } from '@/components/modules/PricingEditor/PricingEditor';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

import { DYNAMIC_PAGE_PATHS } from '../../shared/pathRoutes';

export const PAGE_PRICING_EDITOR: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.PRICING_EDITOR,
  schemesByRoles: [
    {
      roles: [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN],
      titleTextId: 'PRICING_EDITOR',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <PricingEditorModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
          }}
        />
      ),
    },
  ],
};
